module.exports = __webpack_public_path__ + "img/cs.ca7ecb6a.svg";